import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"facebook\"><path fill=\"#7c7c7c\" d=\"M25 23.62c0 .76-.62 1.38-1.38 1.38h-6.37v-9.68h3.25l.49-3.77h-3.74V9.14c0-1.1.3-1.84 1.87-1.84h2V3.92c-.35-.04-1.53-.14-2.91-.14-2.88 0-4.86 1.75-4.86 4.98v2.79H10.1v3.77h3.25V25H1.38C.62 25 0 24.38 0 23.62V1.38C0 .62.62 0 1.38 0h22.24C24.38 0 25 .62 25 1.38v22.24\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol